var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',[_c('CCardHeader',[_c('h3',[_vm._v("Detalle Vendedor")]),_c('h4',[_vm._v(_vm._s(_vm.selectedSeller.nombre_Empleado))])]),_c('CCardBody',[_c('CTabs',[_c('CTab',{attrs:{"title":"Cotizaciones"}}),_c('CTab',{attrs:{"title":"Remisiones"}}),_c('CTab',{attrs:{"title":"Cartera"}}),_c('CTab',{attrs:{"title":"Clientes"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }